import React, {Component} from 'react'
import {Col, Row} from 'react-bootstrap'
import {convertToJalali} from '../../../utils/dateHelper'
import { PersianNumber } from 'react-persian'

class Owner extends Component {
  render () {
    const {info} = this.props
    return (
      <Row key={info.id} className="Owner">
        <Col xs={7}>
          {info.name}
        </Col>
        <Col xs={5}>
          <PersianNumber>{convertToJalali(info.date, 'jDD jMMMM jYY')}</PersianNumber>
        </Col>
      </Row>
    )
  }
}

export default Owner



// WEBPACK FOOTER //
// ./src/components/HorseInfo/Owner/Owner.js